const zhTW = {
};
export default zhTW;
